import { initializeApp } from "firebase/app";
import { getMessaging, onMessage, isSupported } from "firebase/messaging";
import { store } from "./redux/store";
import { setNotification } from "./redux/Reducer/Store/StoreSlice";

const firebaseConfig = {
  apiKey: "AIzaSyBsr46JoORM2xOShfmdADvtafBujUveu5s",
  authDomain: "healthhub-e51c8.firebaseapp.com",
  projectId: "healthhub-e51c8",
  storageBucket: "healthhub-e51c8.firebasestorage.app",
  messagingSenderId: "112769041941",
  appId: "1:112769041941:web:b6e633459cb23cb3bcb01c",
  measurementId: "G-JCWH4199CN",
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
export let messaging = null;

// Check browser support for Firebase Messaging using isSupported()
const initializeMessaging = async () => {
  try {
    // Use Firebase's built-in isSupported() - most reliable check
    const supported = await isSupported();

    if (!supported) {
      console.warn(
        "Browser does not support Firebase Messaging. Push notifications disabled."
      );
      return;
    }

    // Check secure context (HTTPS)
    if (!window.isSecureContext) {
      console.warn(
        "Insecure context detected. Firebase Messaging requires HTTPS."
      );
      return;
    }

    // Initialize messaging only if supported
    messaging = getMessaging(firebaseApp);
    console.log("Firebase Messaging initialized successfully");
  } catch (error) {
    console.warn("Firebase Messaging initialization failed:", error.message);
    messaging = null;
  }
};

// Initialize on app load
initializeMessaging();

export default firebaseApp;

export const onMessageListener = () =>
  new Promise((resolve, reject) => {
    try {
      if (!messaging) {
        // If messaging isn't ready yet, try to wait a bit or initialize
        const checkMessaging = setInterval(() => {
          if (messaging) {
            clearInterval(checkMessaging);
            setupListener(resolve);
          }
        }, 500);
        // Timeout after 5 seconds
        setTimeout(() => clearInterval(checkMessaging), 5000);
        return;
      }

      setupListener(resolve);
    } catch (error) {
      console.error("Error in onMessageListener setup:", error);
      reject(error);
    }
  });

const setupListener = (resolve) => {
  // Use a global flag to ensure only one listener is active
  if (window.fcmListenerRegistered) {
    return;
  }
  window.fcmListenerRegistered = true;

  onMessage(messaging, (payload) => {
    console.log("[Firebase] Message received in foreground:", payload);
    const { title, body } = payload.notification || {};

    // Ignore status indication messages (login/logout/status updates)
    const isStatusMessage =
      payload?.data?.status ||
      ["ACTIVE", "AWAY", "CLOSED", "INACTIVE"].includes(body?.toUpperCase()?.trim());

    if (!isStatusMessage) {
      // Pattern for Order Creation
      const orderIdMatch = body?.match(/Order with ID (\w+) has been successfully created/);
      if (orderIdMatch) {
        const orderId = orderIdMatch[1];
        store.dispatch(setNotification({ 
          title, 
          orderId, 
          receivedAt: Date.now() 
        }));
      } else {
        // General notification update to trigger UI refreshes
        store.dispatch(setNotification({ 
          title, 
          body, 
          receivedAt: Date.now() 
        }));
      }

      // Also trigger a browser notification if granted and in foreground
      if (typeof Notification !== "undefined" && Notification.permission === "granted") {
        new Notification(title || "New Notification", {
          body: body || "",
          icon: "/logo192.png",
        });
      }
    }


    resolve(payload);
  });
};